import * as React from 'react';
import {
	DateField,
	EditButton,
	Identifier,
	ImageField,
	Labeled,
	NumberField,
	Record,
	RecordMap,
	ReferenceField,
	TextField,
	UrlField
} from 'react-admin';
import { Card, CardContent, CardHeader } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useListStyles = makeStyles(theme => ({
	card: {
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		margin: '1.5rem 0',
		boxShadow: '0px 15px 20px #27313f0c !important',
		backgroundColor: 'white'
	},
	cardTitleContent: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between'
	},
	cardContent: theme.typography.body1,
	cardContentRow: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		margin: '0.5rem 0',
		fontWeight: 'bold'
	}
}));

interface MarathonListProps {
	ids?: Identifier[];
	data?: RecordMap<Record>;
	basePath?: string;
}

export const MarathonList = (props: MarathonListProps) => {
	const { ids, data, basePath } = props;
	const classes = useListStyles();

	if (!ids || !data || !basePath) {
		return null;
	}

	return (
		<div style={{ margin: '1em', backgroundColor: '#F8F9FC' }} className="list-container">
			{ids.map(id => (
				<Card key={id} className={classes.card}>
					<CardHeader
						title={
							<div className={classes.cardTitleContent}>
                                <span>
                                    {data[id].name}
                                </span>
								<EditButton
									resource="marathons"
									basePath={basePath}
									record={data[id]}
								/>
							</div>
						}
					/>
					<CardContent className={classes.cardContent}>
						<Labeled label="#" className={classes.cardContentRow}>
							<TextField record={data[id]} source="id" label="#"/>
						</Labeled>
						<Labeled label="FEATURED_IMAGE_URL" className={classes.cardContentRow}>
							<ImageField record={data[id]} source="featuredImageUrl" label="FEATURED_IMAGE_URL"/>
						</Labeled>
						<Labeled label="NAME" className={classes.cardContentRow}>
							<TextField record={data[id]} source="name" label="NAME"/>
						</Labeled>
						<Labeled label="AGENDA" className={classes.cardContentRow}>
							<TextField record={data[id]} source="agenda" label="AGENDA"/>
						</Labeled>
						<Labeled label="DURATION" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="duration" label="DURATION"/>
						</Labeled>
						<Labeled label="DATE" className={classes.cardContentRow}>
							<DateField record={data[id]} source="date" label="DATE"/>
						</Labeled>
						<Labeled label="GROUP_LINK" className={classes.cardContentRow}>
							<UrlField record={data[id]} source="groupLink" label="GROUP_LINK"/>
						</Labeled>
						<Labeled label="COACH" className={classes.cardContentRow}>
							<ReferenceField record={data[id]} source="coachId" label="FORUM" reference="clients">
								<TextField source="fullName"/>
							</ReferenceField>

						</Labeled>
						<Labeled label="NUMBER_OF_PARTICIPANTS" className={classes.cardContentRow}>
							<NumberField record={data[id]} source="participantsIds.length"
							             label="NUMBER_OF_PARTICIPANTS"/>
						</Labeled>
					</CardContent>
				</Card>
			))}
		</div>
	);
};
